import { formatMoney } from "@/helpers/money"
import { SENTINEL_AMOUNT_CENTS } from "@/pricing/models/TieredRatesheet"

// Rates are stored in cents. With a currency code the amount is shown the way
// the tour Costs section shows it (RateDisplay: "$100.00"); without one, as a
// plain two-decimal amount ("100.00"). A missing or sentinel rate renders empty.
const formatRate = (cents, currencyCode?: string): string => {
  if (cents === null || cents === undefined || cents === "" || cents === SENTINEL_AMOUNT_CENTS) {
    return ""
  }

  const amount = Number(cents) / 100

  if (Number.isNaN(amount)) return "-"

  return currencyCode ? formatMoney(amount, currencyCode) : amount.toFixed(2)
}

export default formatRate
